import React, {useState, useEffect, Fragment} from 'react';
import {Spinner} from "react-bootstrap";
import moment from "moment";
import {UE_STAMP_IMG} from "../../constants";

import TemplatePROHeader from "./templates/BASE/TemplatePROHeader";
import Template1BCadastral from "./templates/BASE/Template1BCadastral";
import Template1BLocalisation from "./templates/BASE/Template1BLocalisation";
import Template1BSynthese from "./templates/BASE/Template1BSynthese";
import Template1BUrba2 from "./templates/BASE/Template1BUrba2";
import Template1BRisque from "./templates/BASE/Template1BRisque";
import Template1BPrescription from "./templates/BASE/Template1BPrescription";
import Template1BServitude from "./templates/BASE/Template1BServitude";
import Template1BObservation from "./templates/BASE/Template1BObservation";
import Template1BAgriculture from "./templates/BASE/Template1BAgriculture";
import Template1BEnvironnement from "./templates/BASE/Template1BEnvironnement";
import Template1BPatrimoine from "./templates/BASE/Template1BPatrimoine";
import Template1BNuisanceSonore from "./templates/BASE/Template1BNuisanceSonore";

import Color from "color";


const NRUPROForm = (props) => {

    const [isLoading, setIsLoading] = useState(false)
    const [displayForm, setDisplayForm] = useState("base")
    const [primaryCol, setPrimaryCol] = useState(Color("#323232"))

    useEffect((e)=>{
        setDisplayForm("level1")
    }, [])

    return (
        (isLoading)
            ?<div className="text-center my-2"><Spinner animation="border" size={'sm'}/></div>
            :<div className={'yui3-cssreset ue-container'} id={"eu-data"}>
                <TemplatePROHeader />
                <div className="ue-section ue-form-title" style={{"backgroundColor": primaryCol.hex()}}>
                    <span>NOTE DE RENSEIGNEMENT D'URBANISME</span>
                </div>
                <Template1BCadastral primColor={primaryCol}/>
                <Template1BLocalisation screenCapt={props.screenCapt}/>
                <Template1BSynthese formtype={displayForm} primColor={primaryCol}/>
                <div className="page-break"></div>
                <Template1BUrba2  formtype={displayForm} primColor={primaryCol}/>
                <div className="page-break"></div>
                <Template1BRisque formtype={displayForm} primColor={primaryCol}/>
                <Template1BServitude formtype={displayForm} primColor={primaryCol}/>
                <Template1BPrescription formtype={displayForm} primColor={primaryCol}/>
                <div className="ue-section">
                    <div className="ue-section ue-section-title" style={{"backgroundColor": primaryCol.alpha(0.5)}}>
                        <span >OBSERVATION ET PERIMÈTRE CONCERNÉS</span>
                    </div>
                    <br/>
                    <table className={"ue-table-simple ue-mb-3"}>
                        <thead>
                        <tr className={"ue-table-row-header"}>
                            <th>Description</th>
                            <th className={"text-right"}>Surface</th>
                        </tr>
                        </thead>
                        <tbody>
                        <Template1BAgriculture formtype={displayForm}/>
                        <Template1BEnvironnement formtype={displayForm}/>
                        <Template1BPatrimoine formtype={displayForm}/>
                        <Template1BNuisanceSonore formtype={displayForm}/>
                        <Template1BObservation formtype={displayForm} primColor={primaryCol}/>
                        </tbody>
                    </table>
                </div>
                <div className={"ue-stamp-sign-zone"} style={{"pageBreakInside":"avoid"}}>
                    <div className=" ue-tempon-zone">
                        <div className="ue-dat-valid"><i>Fait à Ajaccio le {moment().format('DD/MM/YYYY')}</i></div>
                        <img src={UE_STAMP_IMG} alt="tempon urbaearth"  style={{"height": "110px"}}/>
                    </div>

                    <div className="text-left ue-foot-note" >
                        <p><i>
                            La présente note d’urbanisme fait état des renseignements fondés sur les documents en vigueur connus à ce jour sous réserve d’un Certificat
                            d’Urbanisme, un permis ou une autorisation susceptible de modifier les renseignements fournis (L410-1 et L442-14 du code de l’urbanisme). Elle
                            constitue un simple document d’information et ne peut en aucun cas être considérée comme une autorisation administrative quelconque, ni un certificat
                            d’urbanisme. Elle renseigne sur la zone où est situé l’immeuble mais n’a pas pour objet de déterminer la constructibilité ou la non constructibilité.
                        </i>
                        </p>
                    </div>
                </div>
            </div>
    );
};


export default NRUPROForm;
